import {
  PLAN_DURATION,
  PLAN_TYPE,
  STUDENT_ROLE,
  type UserInfo,
} from "@/services/api/users/info/get"
import { type StateCreator } from "zustand"
import { create } from "@/app/state"
import { persist } from "zustand/middleware"
import type { LifeUsage } from "@/services/api/users/life-usage/get"

interface UserState {
  user: UserInfo
  setUser: (user: UserInfo) => void
  lifeUsage: {
    list: LifeUsage[]
    lastLifeUsage: string | null
  }
  setLifeUsage: (lifeUsage: LifeUsage[]) => void
}

const state: StateCreator<UserState> = (set) => ({
  user: {
    id: "",
    name: "",
    email: "",
    country: "",
    role: "STUDENT",
    studentRole: STUDENT_ROLE.SECONDARY,
    avatar: "",
    lives: 0,
    learningSessions: [],
    documents: [],
    userPoints: [],
    refillLivesAt: "",
    diagnoseUses: 0,
    phone: null,
    activePlan: {
      id: "",
      name: "",
      duration: PLAN_DURATION.INFINITY,
      type: PLAN_TYPE.FREE,
      endDate: null,
    },
    yearStudy: "",
    studyArea: "",
    createdAt: new Date(),
  },
  lifeUsage: {
    list: [],
    lastLifeUsage: null,
  },
  setUser: (user: UserInfo) => set({ user }),
  setLifeUsage: (lifeUsage: LifeUsage[]) =>
    set({
      lifeUsage: {
        list: lifeUsage,
        lastLifeUsage: lifeUsage.length > 0 ? lifeUsage[lifeUsage.length - 1].createdAt : null,
      },
    }),
})

export const useUser = create<UserState>()(
  persist(state, {
    name: "user_info",
  }),
)
